import { useNewCode } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { BodyText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { SCHEDULE_WITH_CONTACT_PROVIDER } from '../constants'
import { ScheduleWithAContactProvider } from '../schedule_with_a_contact'
import { currentContactProfileSelector } from '../selectors'
import { PromptBlueBox, ItalicText, MeetingHistorySectionHeader } from './styles'

export const EmptyNextMeetingHistory = () => {
  const currentContact = useSelector(currentContactProfileSelector)
  const [isShareStarted, setIsShareStarted] = useState(false)
  const [sharedContact, setIsSharedContact] = useState(null)
  const isButtonsExperimentEnabled = useNewCode('org_expansion_share_cta_feature')?.enabled
  const buttonCopy = isButtonsExperimentEnabled ? I18n.t('publisher.contacts.buttons.book_meeting')
    : I18n.t('publisher.contacts.buttons.create_event')

  const showForDesktop = useDeviceType('isDesktopUp')

  return (
    <>
      <MeetingHistorySectionHeader>
        <BodyText size="medium" color="muted" weight="bold">{I18n.t('publisher.contacts.profile.next_meeting')}</BodyText>
      </MeetingHistorySectionHeader>
      <div>
        <PromptBlueBox>
          <ItalicText>{I18n.t('publisher.contacts.profile.no_next_meeting')}</ItalicText>
          {showForDesktop && (
            <Button
              spacingTop="20"
              onClick={() => {
                setIsSharedContact(currentContact)
                setIsShareStarted(true)
              }}
            >
              {buttonCopy}
            </Button>
          )}
        </PromptBlueBox>
      </div>
      <ScheduleWithAContactProvider
        isFlowStarted={isShareStarted}
        contact={sharedContact}
        onFlowFinish={() => {
          setIsShareStarted(false)
          setIsSharedContact(null)
        }}
        parentSource={SCHEDULE_WITH_CONTACT_PROVIDER.PARENT_COMPONENT.CONTACT_PROFILE}
      />
    </>
  )
}
